import { render, staticRenderFns } from "./DomainLegacy.vue?vue&type=template&id=34fbb65f"
import script from "./DomainLegacy.vue?vue&type=script&lang=js"
export * from "./DomainLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports